// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__nBXQR","page_no_container":"Pagination_page_no_container__0lupE"};